var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticClass: "mt-3",
        attrs: { content: "Ubicación", "has-line": "" }
      }),
      _c(
        "div",
        { staticClass: "row my-3" },
        [
          _c("info-field", {
            staticClass: "col-4",
            attrs: {
              label: "Dirección (línea 1):",
              value: _vm.model.studentDetail?.physicalAddress?.address1
            }
          }),
          _c("info-field", {
            staticClass: "col-4",
            attrs: {
              label: "Dirección (línea 2):",
              value: _vm.model.studentDetail?.physicalAddress?.address2
            }
          }),
          _c("info-field", {
            staticClass: "col-4",
            attrs: { label: "País:", value: "Estados Unidos" }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row my-3" },
        [
          _c("info-field", {
            staticClass: "col-4",
            attrs: {
              label: "Estado:",
              value: _vm.model.studentDetail?.physicalAddress?.state
            }
          }),
          _c("info-field", {
            staticClass: "col-4",
            attrs: {
              label: "Municipio:",
              value: _vm.model.studentDetail?.mipeStudent?.municipality
            }
          }),
          _c("info-field", {
            staticClass: "col-4",
            attrs: {
              "format-type": "postal-code",
              label: "Código postal:",
              value: _vm.model.studentDetail?.physicalAddress?.zipCode
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }